<template>
    <div class="v-messages-list">
        <div v-if="messages.length == 0" class="v-messages-list__no-messages-info">
            Keine Nachrichten vorhanden.
        </div>

        <div v-for="(notification, index) of notificationsFiltered" :key="index" :class="dynamicClass(notification)">
            <div class="v-messages-list__message__header">
                <div>
                    {{ notification.datetime?.toLocaleString() }}
                </div>
                <div>
                    <button aria-label="Nachricht löschen" data-tooltip="Nachricht löschen"
                        @click="removeMessage(notification)">
                        ×
                    </button>
                </div>
            </div>

            <div class="v-messages-list__message__content">
                {{ notification.msg }}
            </div>
        </div>
    </div>
</template>


<script setup lang="ts">
import { useMessages } from '@/composables/useMessages';
import { computed } from 'vue';
const { messages, removeMessage } = useMessages();

const props = withDefaults(defineProps<{
    showMessagesPopup?: boolean
}>(), {
    showMessagesPopup: false
})

const notificationsFiltered = computed(() => {
    return [...messages.value].reverse()
})

const emit = defineEmits<{

    "update:showMessagesPopup": [show: boolean]
}>()

function dynamicClass(notification: any) {
    return {
        'v-messages-list__message': true,
        'x-read': notification.read === true,
        'x-unread': notification.read !== true,
        'x-error': notification.type === 'error',
        'x-warning': notification.type === 'warning',
        'x-info': notification.type === 'info'
    }
}

</script>
